enum ExternalProviderStatus {
  OPTED_IN = 'OPTED_IN',
  NOT_OPTED_IN = 'NOT_OPTED_IN',
  EXPIRED = 'EXPIRED',
}

export default ExternalProviderStatus;
